export const IntroTemplate = ({ introForm }) => {
    return (
        <div className="border-b">
            <p className="p-3 font-bold text-xl border-b">Intro</p>
            <ul>
                <li className="border-dashed border-b p-3">
                    <span className="font-bold">Company Name:</span>
                    {" "}{introForm.companyName}
                </li>
                <li className="border-dashed border-b p-3">
                    <span className="font-bold">Problem Statement:</span>
                    {" "}{introForm.problemStatement}
                </li>
                <li className="p-3">
                    <span className="font-bold">Problem Solution:</span>
                    {" "}{introForm.problemSolution}
                </li>
            </ul>
        </div>
    )
}